import React from 'react';
import styled from 'styled-components';

import { founderTypes } from '../data/founderTypes';

const DriverList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const DriverItem = styled.li`
  padding: 0.85rem 1rem;
  border-radius: 12px;
  background: ${(props) =>
    props.$variant === 'print' ? '#fafafa' : 'rgba(255, 255, 255, 0.03)'};
  border: 1px solid ${(props) => {
    if (props.$variant === 'print') return props.$highlight ? '#ccc' : '#e6e6e6';
    return props.$highlight ? `${props.$color}44` : 'rgba(255, 255, 255, 0.08)';
  }};
  break-inside: avoid;
`;

const DriverTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.35rem;
`;

const TypeBadge = styled.span`
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${(props) => (props.$variant === 'print' ? '#333' : props.$color || 'var(--primary-color)')};
  padding: 0.2rem 0.45rem;
  border-radius: 999px;
  background: ${(props) =>
    props.$variant === 'print' ? '#eee' : `${props.$color || 'var(--primary-color)'}18`};
  border: 1px solid ${(props) =>
    props.$variant === 'print' ? '#ddd' : `${props.$color || 'var(--primary-color)'}33`};
  white-space: nowrap;
`;

const WeightTag = styled.span`
  font-size: 0.72rem;
  font-weight: 600;
  color: ${(props) => (props.$variant === 'print' ? '#666' : 'rgba(255, 255, 255, 0.45)')};
`;

const QuestionText = styled.p`
  margin: 0;
  font-size: 0.92rem;
  font-weight: 600;
  color: ${(props) => (props.$variant === 'print' ? '#111' : 'var(--text-primary)')};
  line-height: 1.45;
`;

const AnswerText = styled.p`
  margin: 0.35rem 0 0;
  font-size: 0.88rem;
  color: ${(props) => (props.$variant === 'print' ? '#444' : 'var(--text-secondary)')};
  line-height: 1.5;
`;

const ResultDriversList = ({
  drivers = [],
  primaryType = null,
  variant = 'screen',
  highlightPrimary = true,
}) => {
  if (!drivers.length) return null;

  return (
    <DriverList>
      {drivers.map((driver, idx) => {
        const typeMeta = founderTypes[driver.type];
        const isPrimary = highlightPrimary && driver.type === primaryType;
        return (
          <DriverItem
            key={`${driver.questionId || idx}-${driver.optionId || idx}`}
            $highlight={isPrimary}
            $color={typeMeta?.color}
            $variant={variant}
          >
            <DriverTop>
              <TypeBadge $color={typeMeta?.color} $variant={variant}>
                {typeMeta?.code || driver.type}
              </TypeBadge>
              {driver.weight > 1 && (
                <WeightTag $variant={variant}>×{driver.weight} weight</WeightTag>
              )}
            </DriverTop>
            <QuestionText $variant={variant}>{driver.questionText || 'Question'}</QuestionText>
            {driver.optionText && (
              <AnswerText $variant={variant}>You chose: {driver.optionText}</AnswerText>
            )}
          </DriverItem>
        );
      })}
    </DriverList>
  );
};

export default ResultDriversList;
